export default __webpack_public_path__ + "src/images/packages/summerfields-rose-retreat/fa3bd66bcb439a06096e03f1833b967e-2.jpg";